import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TitleMixin extends Vue {
	public updated() {
		const pageTitle = this.getTitle(this);
		if (pageTitle) {
			document.title = pageTitle;
		}
	}
	public beforeDestroy() {
		document.title = 'Levno | Admin UI';
	}

	public getTitle(vm: this) {
		// @ts-ignore
		const { pageTitle } = vm;
		if (pageTitle) {
			return typeof pageTitle === 'function' ? pageTitle.call(vm) : pageTitle;
		}
	}
}
